module.exports = __webpack_public_path__ + "img/learner-avatars.a0c3bfd5.png";